type CookieList = Record<string, string>;

const getCookie = (name: string): string | undefined => {
    if (document.cookie) {
        const cookieList: CookieList = document.cookie
            .split('; ')
            .reduce((cookieList: CookieList, keyVal: string) => {
                const parts = keyVal.split('=');
                cookieList[parts[0]] = parts[1];
                return cookieList;
            }, {});
        return cookieList[name];
    }
    return undefined;
};

const setCookie = (name: string, value: string, skipIfExists: boolean = false): void => {
    if (skipIfExists && document.cookie.includes(name)) return;
    const domain = window.location.hostname?.split('.').slice(-2).join('.');
    document.cookie = `${name}=${value}; Domain=${domain}`;
};

export { getCookie, setCookie };
